export const CALLSECT_SEO_TITLE =
  "AI Call Analysis & Relationship Intelligence | Callsect";

export const CALLSECT_SOCIAL_TITLE =
  "Your personal relationship intelligence for customer calls.";

export const CALLSECT_META_DESCRIPTION =
  "Analyze customer calls with evidence-backed insights, practical coaching, CRM-ready notes, and relationship context that carries into the next conversation.";

export const CALLSECT_SOCIAL_DESCRIPTION =
  "Understand what happened, what it meant, and what to do next. Callsect connects call analysis, coaching, CRM notes, and relationship memory.";

export const CALLSECT_HERO_TITLE =
  "Your personal relationship intelligence for customer calls.";

export const CALLSECT_AUDIENCE_LINE =
  "Built for anyone whose success depends on customer calls.";

export const CALLSECT_SOCIAL_IMAGE_PATH =
  "/callsect-social-preview-relationship-intelligence-v8.png";

export const CALLSECT_SOCIAL_IMAGE_ALT =
  "Callsect: your personal relationship intelligence for customer calls. A CRM remembers fields, a summarizer remembers one call, and Callsect remembers the relationship.";
